import { formatarData } from 'src/app/core/utils/utilities';
import { Component, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaixaService } from 'src/app/services/CaixaService/caixa.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';

interface IOptions {
  name: string;
  value: number;
}

@Component({
  selector: 'app-modal-relatorios-mensais-caixa',
  templateUrl: './modal-relatorios-mensais-caixa.component.html',
  styleUrls: ['./modal-relatorios-mensais-caixa.component.scss']
})
export class ModalRelatoriosMensaisCaixaComponent implements OnInit {
  form: FormGroup;
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalRelatoriosMensaisCaixaComponent>,
    private fb: FormBuilder,
    private caixaService: CaixaService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  tableData: any[] = [];

  tableColumns = [
    {
      header: 'Código',
      key: 'PK_CAIX',
      type: 'text'
    },
    {
      header: 'Data de Abertura',
      key: 'DT_ABTR_CAIX',
      type: 'text'
    },
    {
      header: 'Data de Fechamento',
      key: 'DT_FECH_CAIX',
      type: 'text'
    },
    {
      header: 'Valor de Abertura',
      key: 'VL_ABTR_CAIX',
      type: 'text'
    },
    {
      header: 'Valor de Fechamento',
      key: 'VL_FECH_CAIX',
      type: 'text'
    },
    {
      header: '',
      key: 'selecionar',
      type: 'checkbox',
      action: (item: any) => this.selectCaixa(item)
    }
  ];

  mesOptions: IOptions[] = [
    {
      name: 'Janeiro',
      value: 1
    },
    {
      name: 'Fevereiro',
      value: 2
    },
    {
      name: 'Março',
      value: 3
    },
    {
      name: 'Abril',
      value: 4
    },
    {
      name: 'Maio',
      value: 5
    },
    {
      name: 'Junho',
      value: 6
    },
    {
      name: 'Julho',
      value: 7
    },
    {
      name: 'Agosto',
      value: 8
    },
    {
      name: 'Setembro',
      value: 9
    },
    {
      name: 'Outubro',
      value: 10
    },
    {
      name: 'Novembro',
      value: 11
    },
    {
      name: 'Dezembro',
      value: 12
    }
  ];

  anoOptions: IOptions[] = [];

  initForm(): FormGroup {
    const form = this.fb.group({
      PK_CAIX: [null, Validators.required],
      NU_MONTH: [null, Validators.required],
      NU_YEAR: [null, Validators.required]
    });
    return form;
  }

  getAnoOptions(): void {
    const currentYear = new Date().getFullYear();
    this.anoOptions = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => {
      const year = i + 2024;
      return { name: year.toString(), value: year };
    });
  }

  getCaixasPorData(): void {
    const NU_MONTH = this.form.controls['NU_MONTH'].value;
    const NU_YEAR = this.form.controls['NU_YEAR'].value;
    if (!NU_MONTH || !NU_YEAR) return;
    this.isLoading = true;
    this.caixaService
      .GetCaixasMonthYearDataAbertura(NU_MONTH, NU_YEAR)
      .subscribe({
        next: res => {
          this.tableData = res.map(x => {
            return {
              PK_CAIX: x.PK_CAIX,
              DT_ABTR_CAIX: formatarData(x.DT_ABTR_CAIX),
              DT_FECH_CAIX: formatarData(x.DT_FECH_CAIX),
              VL_ABTR_CAIX: x.VL_ABTR_CAIX?.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }),
              VL_FECH_CAIX: x.VL_FECH_CAIX?.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }),
              FL_CAIX_ABRT: x.FL_CAIX_ABRT,
              selecionar: false
            };
          });
          this.isLoading = false;
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  getRelatorio(): void {
    this.isLoading = true;
    const PK_CAIX = this.form.controls['PK_CAIX'].value;
    const NU_MONTH = this.form.controls['NU_MONTH'].value;
    const NU_YEAR = this.form.controls['NU_YEAR'].value;
    this.caixaService.GetReceiptCaixaById(PK_CAIX).subscribe({
      next: res => {
        this.appExportBase64.downloadPDF(
          res.ReportBase64,
          `Relatório Mensal de Caixa ${NU_MONTH}-${NU_YEAR}`
        );
        this.isLoading = false;
      },
      error: err => {
        this.isLoading = false;
      }
    });
  }

  getRelatorioTxt(): void {
    this.isLoading = true;
    const PK_CAIX = this.form.controls['PK_CAIX'].value;
    const NU_MONTH = this.form.controls['NU_MONTH'].value;
    const NU_YEAR = this.form.controls['NU_YEAR'].value;
    this.caixaService.GetReceiptCaixaById(PK_CAIX, 1).subscribe({
      next: res => {
        this.impressoraService.impressoraTicket(
          res.ReportBase64,
          'text/plain'
        );
        this.isLoading = false;
      },
      error: err => {
        this.isLoading = false;
      }
    });
  }

  selectCaixa(item: any) {
    this.tableData = this.tableData.map((x: any) => {
      return {
        ...x,
        selecionar: x.PK_CAIX === item.PK_CAIX ? true : false
      };
    });

    const PK_CAIX = item.PK_CAIX;
    this.form.controls['PK_CAIX'].setValue(PK_CAIX);
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  onChangeMes(event: number): void {
    this.tableData = [];
    this.form.controls['PK_CAIX'].setValue(null);
    this.form.controls['NU_MONTH'].setValue(event);
  }

  onChangeAno(event: number): void {
    this.tableData = [];
    this.form.controls['PK_CAIX'].setValue(null);
    this.form.controls['NU_YEAR'].setValue(event);
  }

  activateRoute(): void {
    this.getAnoOptions();
    if (this.data && this.data.id) {
      this.form.controls['FK_GATE_ENTR'].setValue(this.data.id);
    }
  }
}
